module.exports = __webpack_public_path__ + "static/media/12.a715aea0.jpg";